import { QueryClient } from "@tanstack/react-query";
import { ACCOUNT_INIT_QUERY_KEY } from "../../../appStore";
import { GET_ACCOUNT_ME_QUERY_KEY } from "../../auth/api/authApi";

export async function refreshHydratedAccount(queryClient: QueryClient) {
  await queryClient.invalidateQueries({
    queryKey: ACCOUNT_INIT_QUERY_KEY,
    exact: true,
    refetchType: "none",
  });
  await queryClient.refetchQueries({
    queryKey: ACCOUNT_INIT_QUERY_KEY,
    exact: true,
    type: "active",
  });

  return queryClient.getQueryData(GET_ACCOUNT_ME_QUERY_KEY);
}
